import React, { FC } from 'react';

import { RestricoesBuscaSolicitacoesFormulario, RestricoesCamposBuscaSolicitacoesFormulario } from 'business/formulario/RestricoesBuscaSolicitacoesFormulario';
import { SolicitacoesPage } from './SolicitacoesPage';
import { useRestricoesFormulario } from 'service/restricao/useRestricoesFormulario/useRestricoesFormulario';
import { useAutorizacao } from 'view/component/Autorizacao/useAutorizacao';
import { LoadingTexto } from 'view/component/Tipografia/Texto';
import { SolicitacoesAction } from 'store/Solicitacoes/Solicitacoes.action';


export const SolicitacoesDoReinoPage: FC = () => {
  const restricoes: RestricoesCamposBuscaSolicitacoesFormulario = useRestricoesFormulario(RestricoesBuscaSolicitacoesFormulario) as any;
  const autorizacao = useAutorizacao();
  const reino = autorizacao.membroUnidade?.unidade.reino;
  const titulo = <>Solicitações - {reino?.sigla ? reino.sigla : <LoadingTexto tipo="span" />}</>;

  const buscaPadrao = () => SolicitacoesAction.lista.iniciarUnidadesDoReino(autorizacao.membroUnidade?.unidade.id);

  return <SolicitacoesPage
    titulo={titulo}
    restricoes={restricoes}
    papel={autorizacao.maiorPermissao}
    gerarActionBuscaPadrao={buscaPadrao} />
}
